module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst renderMode = ((storage || {}).request || {}).renderMode || ''\nconst documentType = useDocumentType || false\nlet qrCodeHTML = ''\nif (documentType) {\nif (model.tripAttributes[documentType + 'Url'] && model.tripAttributes[documentType + 'QRCodePDF']) {\nqrCodeHTML = '<a href=\"' + model.tripAttributes[documentType + 'Url'] + '.pdf\" target=\"_blank\"><img width=\"80\" height=\"80\" alt=\"\" src=\"' + model.tripAttributes[documentType + 'QRCodePDF'] + '\"></a>'\n}\n}\n%><section class=\"footer\" style=\"padding-top: 10px; padding-bottom: 0; width: 100%; display: flex; flex-direction: column; font-size: 12px;\">\n<style>\n.footer {\npadding: 0 60px;\n}\n.footer table tr td {\nfont-family: \"Roboto Condensed\", sans-serif, Arial;\nfont-weight: 400;\nfont-style: normal;\nfont-size: 12px;\ncolor: #777777;\n}\n.footer table tr td:first-child {\ntext-align: left;\n}\n.footer table tr td:last-child {\ntext-align: right;\n}\n</style>\n<div class=\"main\" style=\"display: flex; flex-direction: row; align-items: flex-start; justify-content: space-between;\">\n<table style=\"width:100%\">\n<tbody>\n<tr>\n<td class=\"olc\" style=\"width: 40%; padding: 0; line-height: 1.2; vertical-align: top;\">\n<table style=\"width:100%\">\n<tbody>\n<tr><td colspan=\"2\" style=\"text-align: left\"><strong>Ihre Zahlung erbitten wir an:</strong></td></tr>\n<tr><td style=\"padding-right:20px\">Bankinstitut:</td><td>RaiBa Neufelden</td></tr>\n<tr><td>Empfänger:</td><td>Schörgenhuber Personenbeförderung GmbH</td></tr>\n<tr><td>IBAN:</td><td>AT93 3430 0000 0071 0335</td></tr>\n<tr><td>IBAN:</td><td>AT82 3430 0000 0071 2570</td></tr>\n</tbody>\n</table>\n</td>\n<td class=\"olc\" style=\"width: 20%; padding: 0; line-height: 1.2; vertical-align: middle; text-align: center;\">\n<%- qrCodeHTML %>\n</td>\n<td style=\"width: 40%; padding: 0; line-height: 1.2; text-align: right; vertical-align: top;\">\n<table style=\"width:100%\" align=\"right\">\n<tbody>\n<tr><td colspan=\"2\" style=\"text-align: right\"><strong>Schörgenhuber Personenbeförderung GmbH</strong></td></tr>\n<tr><td style=\"padding-right:20px\">Geschäftsführer:</td><td>Thomas Schörgenhuber</td></tr>\n<tr><td>UID:</td><td>ATU73189328</td></tr>\n<tr><td>Firmenbuch:</td><td>FN488620i</td></tr>\n<tr><td>Firmengericht:</td><td>Landesgericht Linz</td></tr>\n</tbody>\n</table>\n</td>\n</tr>\n</tbody>\n</table>\n</div><%\nif(renderMode === 'html'){\n%><div style=\"text-align: center; margin: 0 0 0 0; color: lightgray;\"><%\n%><%= storage.__('document.general.pageNumberPrefix') %> <span class=\"pageNumber\"></span> / <span class=\"totalPages\"></span><%\n%></div><%\n}\n%></section>"
  , __filename = "components/templates/core/documents/document/footer.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const renderMode = ((storage || {}).request || {}).renderMode || ''
const documentType = useDocumentType || false
let qrCodeHTML = ''
if (documentType) {
if (model.tripAttributes[documentType + 'Url'] && model.tripAttributes[documentType + 'QRCodePDF']) {
qrCodeHTML = '<a href="' + model.tripAttributes[documentType + 'Url'] + '.pdf" target="_blank"><img width="80" height="80" alt="" src="' + model.tripAttributes[documentType + 'QRCodePDF'] + '"></a>'
}
}

    ; __line = 10
    ; __append("<section class=\"footer\" style=\"padding-top: 10px; padding-bottom: 0; width: 100%; display: flex; flex-direction: column; font-size: 12px;\">\n<style>\n.footer {\npadding: 0 60px;\n}\n.footer table tr td {\nfont-family: \"Roboto Condensed\", sans-serif, Arial;\nfont-weight: 400;\nfont-style: normal;\nfont-size: 12px;\ncolor: #777777;\n}\n.footer table tr td:first-child {\ntext-align: left;\n}\n.footer table tr td:last-child {\ntext-align: right;\n}\n</style>\n<div class=\"main\" style=\"display: flex; flex-direction: row; align-items: flex-start; justify-content: space-between;\">\n<table style=\"width:100%\">\n<tbody>\n<tr>\n<td class=\"olc\" style=\"width: 40%; padding: 0; line-height: 1.2; vertical-align: top;\">\n<table style=\"width:100%\">\n<tbody>\n<tr><td colspan=\"2\" style=\"text-align: left\"><strong>Ihre Zahlung erbitten wir an:</strong></td></tr>\n<tr><td style=\"padding-right:20px\">Bankinstitut:</td><td>RaiBa Neufelden</td></tr>\n<tr><td>Empfänger:</td><td>Schörgenhuber Personenbeförderung GmbH</td></tr>\n<tr><td>IBAN:</td><td>AT93 3430 0000 0071 0335</td></tr>\n<tr><td>IBAN:</td><td>AT82 3430 0000 0071 2570</td></tr>\n</tbody>\n</table>\n</td>\n<td class=\"olc\" style=\"width: 20%; padding: 0; line-height: 1.2; vertical-align: middle; text-align: center;\">\n")
    ; __line = 45
    ; __append( qrCodeHTML )
    ; __append("\n</td>\n<td style=\"width: 40%; padding: 0; line-height: 1.2; text-align: right; vertical-align: top;\">\n<table style=\"width:100%\" align=\"right\">\n<tbody>\n<tr><td colspan=\"2\" style=\"text-align: right\"><strong>Schörgenhuber Personenbeförderung GmbH</strong></td></tr>\n<tr><td style=\"padding-right:20px\">Geschäftsführer:</td><td>Thomas Schörgenhuber</td></tr>\n<tr><td>UID:</td><td>ATU73189328</td></tr>\n<tr><td>Firmenbuch:</td><td>FN488620i</td></tr>\n<tr><td>Firmengericht:</td><td>Landesgericht Linz</td></tr>\n</tbody>\n</table>\n</td>\n</tr>\n</tbody>\n</table>\n</div>")
    ; __line = 61
    ; 
if(renderMode === 'html'){

    ; __line = 63
    ; __append("<div style=\"text-align: center; margin: 0 0 0 0; color: lightgray;\">")
    ; 

    ; __line = 64
    ; __append(escapeFn( storage.__('document.general.pageNumberPrefix') ))
    ; __append(" <span class=\"pageNumber\"></span> / <span class=\"totalPages\"></span>")
    ; 

    ; __line = 65
    ; __append("</div>")
    ; 
}

    ; __line = 67
    ; __append("</section>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/document/footer.ejs

}